export default {
    baseStyle: {
        content: {
            margin: '0 auto',
            width: '100%',
            maxWidth: {base: '384px', lg: '600px'},
            maxHeight: {base: '496px', lg: 'unset'},
            color: 'black.100',
            bgColor: 'white',
            borderRadius: '5px !important'
        },

        header: {
            bgColor: 'white',
            paddingX: {base: '20px', lg: '40px'},
            paddingTop: {base: '30px', lg: '50px'},
            paddingBottom: '0'
        },

        heading: {
            fontFamily: 'cormorant',
            fontWeight: '400',
            color: 'black.100',
            fontSize: {base: '27px', lg: '30px'},
            lineHeight: 'normal',
            textAlign: 'center'
        },

        body: {
            bgColor: 'white',
            border: 'none',
            paddingX: {base: '20px', lg: '40px'},
            paddingTop: {base: '30px', lg: '50px'},
            paddingBottom: {base: '30px', lg: '50px'}
        },

        columns: {
            flexDirection: {base: 'column', lg: 'row'},
            alignItems: {base: 'center', lg: 'flex-start'},
            justifyContent: 'center',
            gap: {base: '24px', lg: '40px'}
        },

        column: {
            flex: {lg: '1'},
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center'
        },

        addressHeading: {
            fontFamily: 'cormorant',
            fontWeight: '400',
            color: 'black.100',
            fontSize: '23px',
            lineHeight: 'normal',
            marginBottom: '16px'
        },

        addressText: {
            fontFamily: 'body',
            color: 'black.100',
            fontWeight: '300',
            fontSize: '16px',
            lineHeight: '25px',
            letterSpacing: '0.08px'
        },

        actions: {
            flexDirection: 'column',
            alignItems: 'center',
            gap: '14px',
            marginTop: {base: '30px', lg: '50px'}
        },

        primaryButton: {
            fontFamily: 'body',
            fontWeight: '400',
            fontSize: '17px',
            lineHeight: '26px',
            height: 'auto',
            width: '100%',
            maxWidth: '296px',
            paddingX: '24px',
            paddingY: '15px',
            whiteSpace: 'normal',
            borderRadius: '90px',
            border: '1px solid',
            borderColor: 'teal.500',
            bg: 'teal.500',
            color: 'white',
            _hover: {
                bg: {base: 'teal.500', lg: 'teal.400'},
                borderColor: {base: 'teal.500', lg: 'teal.400'},
                color: 'white',
                textDecoration: 'none'
            },
            _active: {bg: 'teal.400', borderColor: 'teal.400'}
        },

        secondaryButton: {
            fontFamily: 'body',
            fontWeight: '400',
            fontSize: '17px',
            lineHeight: '26px',
            height: 'auto',
            width: '100%',
            maxWidth: '296px',
            paddingX: '24px',
            paddingY: '15px',
            whiteSpace: 'normal',
            borderRadius: '90px',
            border: '1px solid',
            borderColor: 'teal.500',
            bg: 'white',
            color: 'black.100',
            _hover: {
                bg: {base: 'white', lg: 'gray.50'},
                borderColor: 'teal.500',
                color: 'black.100',
                textDecoration: 'none'
            },
            _active: {bg: 'gray.50'}
        }
    }
}
